import { message } from "antd";
import { useMutation, useQueryClient } from "react-query";
import { $api } from "../services/RequestService";
import { amoCrmEndpoints, websiteEndpoints } from "../utils/constants/apis";
import { queryNames } from "../utils/constants/queryNames";
import { CreateLeadAmo } from "../utils/modules/CreateLeadAmo";
import i18n from "../services/i18n";
import queryString from "query-string";

export function usePetitionCreate(id: number) {
  const qc = useQueryClient();
  return useMutation(
    async (data: { leadId: string; flatId: string }) => {
      const res = await $api.post(
        amoCrmEndpoints.PETITION_CREATE +
          `?leadId=${data.leadId}&flatId=${data.flatId}`
      );
      return res.data;
    },
    {
      onSuccess: (data) => {
        message.success(i18n.t("saved"));
        qc.invalidateQueries([queryNames.FLAT_DATA_BY, id]);
      },
      onError: (err: any) => {
        // The backend sends the message as a per-language object; fall back to
        // uz when it has no entry for the client's language.
        const backendMessage = err.response?.data?.message;
        message.error(
          backendMessage?.[i18n.language] ??
            backendMessage?.uz ??
            i18n.t("lead_error")
        );
      },
    }
  );
}

export function useCreateLead() {
  return useMutation(
    async (data: CreateLeadAmo) => {
      const res = await $api.post(websiteEndpoints.CREATE_LEAD_AMO_CRM, data, {
        headers: {
          "X-Auth": String(queryString.parse(window.location.search)?.token),
        },
      });
      return res.data;
    },
    {
      onSuccess: () => {
        message.success(i18n.t("lead_success"));
      },
      onError: () => {
        message.error(i18n.t("lead_error"));
      },
    }
  );
}

export function useExternalSource() {
  return useMutation(
    async (data: {
      name: string;
      phoneNumber: string;
      esType?: "WEBSITE";
      tagList?: string[];
      message?: string;
    }) => {
      const res = await $api.post(
        "/v1/external-source",
        {
          esType: "WEBSITE",
          ...data,
        },
        {
          headers: {
            "X-Auth": String(queryString.parse(window.location.search)?.token),
          },
        }
      );
      return res.data;
    },
    {
      onSuccess: () => {
        message.success(i18n.t("lead_success"));
      },
      onError: () => {
        message.error(i18n.t("lead_error"));
      },
    }
  );
}
